export const styleTemplatesPageMessages = {
  title: 'Style Templates',
  subtitle: 'Manage story style templates for consistent storytelling',
  createButton: 'Create Style Template',
  noTemplatesFound: 'No style templates found',
  noTemplatesDescription: 'Create your first style template to get started',
} as const;
